import React from 'react';
import Reasons from '../Reasons';

function aboutWhy() {
  return (
    <>
      <Reasons />
    </>
  )
}

export default aboutWhy